import { Component } from 'react';
import { fromJS } from 'immutable';
import { FormattedMessage, injectIntl } from 'react-intl';

// COMPONENTS
import { RadioButton } from 'components/RadioButtons';
import MaybeTranslation from 'components/MaybeTranslation';
import { CancelButton, PrimaryButton } from 'components/Buttons';

// STYLES
import {
  ButtonsContainer,
  FilterFormContainer,
  FilterFormTitle,
  FilterInput,
  FilterItemGroup,
  RadioContainer,
} from './styles';

import { FILTER_FORM } from 'constants/filters';

class StringConfiguration extends Component {
  state = {
    query: '',
    option: FILTER_FORM.string[0],
  };

  getOptions = () => {
    // @ts-expect-error TS(2339): Property 'column' does not exist on type 'Readonly... Remove this comment to see the full error message
    const excluded = this.props.column.get('excludeOperators');
    if (!excluded) return FILTER_FORM.string;
    return FILTER_FORM.string.filter((item) => !excluded.includes(item.translation));
  };

  getFormItems = () =>
    this.getOptions().map((item) => (
      <FilterItemGroup key={`string-filter-${item.translation}`} data-testid={`filter__${item.translation}`}>
        <RadioContainer>
          <RadioButton
            renderedValue={{
              translationId: `components.Filters.${item.translation}`,
            }}
            // @ts-expect-error TS(2769): No overload matches this call.
            selected={item.translation === this.state.option.translation}
            onClick={this.handleChangeOption(item)}
          />
        </RadioContainer>

        {item.translation === this.state.option.translation && this.state.option.type === 'input' && (
          <FilterInput
            type="text"
            name="query"
            // @ts-expect-error TS(2339): Property 'intl' does not exist on type 'Readonly<{... Remove this comment to see the full error message
            placeholder={this.props.intl.formatMessage({
              id: 'components.Filters.valuePlaceholder',
            })}
            value={this.state.query}
            onChange={this.handleChangeQuery}
          />
        )}
      </FilterItemGroup>
    ));

  handleChangeQuery = (event) => {
    this.setState({ query: event.currentTarget.value });
  };

  handleChangeOption = (option) => () => {
    this.setState({ option });
  };

  handleSaveFilter = () => {
    let value = null;

    if (this.state.option.type) {
      value = this.state.query;
    } else if (this.state.option.translation === 'isKnown') {
      value = '0';
    } else if (this.state.option.translation === 'isUnknown') {
      value = '1';
    }

    // @ts-expect-error TS(2339): Property 'onSave' does not exist on type 'Readonly... Remove this comment to see the full error message
    this.props.onSave(
      fromJS({
        comparator: this.state.option.comparator,
        // @ts-expect-error TS(2339): Property 'column' does not exist on type 'Readonly... Remove this comment to see the full error message
        field: this.props.column.get('name'),
        value,
      })
    );
  };

  render() {
    return (
      <FilterFormContainer>
        <FilterFormTitle>
          {/* @ts-expect-error TS(2339): Property 'column' does not exist on type 'Readonly... Remove this comment to see the full error message */}
          <MaybeTranslation renderedValue={this.props.column.get('title')} />
        </FilterFormTitle>

        {this.getFormItems()}

        <ButtonsContainer>
          {/* @ts-expect-error TS(2339): Property 'onCancel' does not exist on type 'Readon... Remove this comment to see the full error message */}
          <CancelButton onClick={this.props.onCancel} />
          <PrimaryButton data-testid="filters__apply" onClick={this.handleSaveFilter}>
            <FormattedMessage id="components.Filters.apply" />
          </PrimaryButton>
        </ButtonsContainer>
      </FilterFormContainer>
    );
  }
}

// @ts-expect-error TS(2769): No overload matches this call.
export default injectIntl(StringConfiguration);
